import {React, _} from '@api'
import {useStores} from '@modules'
import {LineItem, LineItemLeft, LineItemRight, LineItemText} from '@modules/pdf/templates/ysl/product/YslProductCard.styles'
import {styled} from '@pdf'
import {StoresInstance} from '@stores'

interface ISpecHexPdf {
  hex: string,
  style?: any
}

export const SpecHexPdf = ({hex, style}: ISpecHexPdf) => {
  const stores = useStores(),
    {SpecHexRoot} = PDFComponents(stores)

  return <SpecHexRoot style={{backgroundColor: hex, ...style}}/>
}

export const ProductCardLineItem: React.FunctionComponent<{ style?, left?, right?, leftTextStyle?, rightTextStyle?, columns? }> = ({style, left, right, leftTextStyle, rightTextStyle, columns}) => {
  const stores = useStores(),
    {LineItem, LineItemLeft, LineItemRight, LineItemText} = PDFComponents(stores)
  return (
    <LineItem style={style}>
      {left && <LineItemLeft>{_.isString(left) ? <LineItemText columns={columns} style={leftTextStyle}>{left}</LineItemText> : left}</LineItemLeft>}
      {right && <LineItemRight>{_.isString(right) ? <LineItemText columns={columns} style={rightTextStyle}>{right}</LineItemText> : right}</LineItemRight>}
    </LineItem>
  )
}

export const PDFComponents = (stores: StoresInstance) => {
  const {catalog: {pdfConfig: {defaultTemplate: {productPage: {fontFamily}}}}, pdf: {cardWidth, cardHeight, cardMargin, imageHeight, cardFontSize, detailViewMargin, labelFontSize}} = stores
  return {
    RootView: styled.View`
      display: flex;
      flex-direction: column;
      background-color: white;
      font-family: Roboto Regular;
      overflow: hidden;
      flex-grow: 0;
      flex-shrink: 0;
      width: ${cardWidth}px;
      height: ${cardHeight - cardMargin}px;
      margin: ${cardMargin / 2}px;
      padding: 0px;
    `,
    VlpImageContainer: styled.View`
      background-color: white;
      justify-self: stretch;
      height: ${imageHeight}px;
      width: 100%;
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      padding: 0;
      margin: 0;
      position: relative;
    `,

    Title: styled.Text`
      font-size: ${cardFontSize}px;
      /* font-family: Graphik Medium;*/
      /* font-weight: bold; */
    `,
    SubTitle: styled.Text`
      font-size: ${cardFontSize}px;
    `,
    Specs: styled.View`
      font-size: ${cardFontSize}px;
    `,
    DetailView: styled.View`
      text-align: left;
      margin-top: ${detailViewMargin}px;
      padding-top: 0px;
      width: 100%;
      font-family: Roboto Regular;
    `,
    NoImageView: styled.View`
      display: flex;
      width: 100%;
      height: 100%;
      flex: 1;
      justify-content: center;
    `,
    NoImageProduct: styled.Image`
      display: flex;
      position: absolute;
      height: '100%';
      width: '100%';
    `,
    ProductImage: styled.Image`
      display: block;
      height: 100%;
      width: 100%;
      object-fit: contain;
    `,
    EmptyProductImage: styled.View`
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    `,
    NoImage: styled.Image`
      display: block;
      height: 100%;
      width: 100%;
      object-fit: contain;
    `,
    NoImageText: styled.Text`
      font-size: 12px;
      font-family: Roboto Regular;
      color: #dedede;
      margin-right: 10px;
    `,
    LineItemLink: styled.Link`
      color: #333333;
      text-decoration: none;
    `,
    LineItem: styled.View`
      display: flex;
      overflow: hidden;
      max-width: ${props => props.columns == 'standard' ? '120px' : props.columns == 'compact' ? '90px' : '120px'};
      max-height: ${props => props.columns == 'standard' ? '20px' : props.columns == 'compact' ? '14px' : '20px'};
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
    `,
    LineItemLeft: styled.View`
      font-size: ${labelFontSize}px;
      display: flex;
      flex-direction: row;
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 100%;
      border: none;
      color: grey;
    `,
    LineItemRight: styled.View`
      font-size: ${cardFontSize}px;
      display: flex;
      flex-direction: row;
      align-content: center;
      align-items: center;
      flex-grow: 1;
      flex-shrink: 0;
      flex-basis: 100%;
      overflow: hidden;
    `,
    LineItemText: styled.Text`
      margin: auto 0;
      text-overflow: ellipsis;
      overflow: hidden;
      max-lines: 1;
      flex-shrink: 1;
      font-family: ${fontFamily.lineItemText};
    `,
    LineItemTextImage: styled.Image`
      margin: auto 0;
      overflow: hidden;
      object-fit: contain;
      object-position: center left;
      flex-shrink: 1;
    `,
    TitleText: styled.Text`
      flex-grow: 0;
      flex-shrink: 1;
      margin: auto 0;
      font-family: ${fontFamily.filterFooter};
      font-size: 8pt;
      display: block;
      white-space: pre-wrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `,
    StarImage: styled.Image`
      width: 16px;
      height: 16px;
      position: absolute;
      z-index: 999;
    `,
    SpecImageContainer: styled.View`
      height: ${p => p.height * 0.65}px;
      background-color: white;
      width: 100%;
      margin: auto auto 0 auto;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      margin-right: 1em;
    `,
    SpecTitleView: styled.View`
      min-width: ${p => p.width}px;
      width: ${p => p.width}px;
      max-width: ${p => p.width}px;
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      height: auto;
      padding: 2px;
      margin: 0px ${props => props.columnSize ? 0 : props.margin}px 0px 0px;
    `,
    SpecHexRoot: styled.View`
      background-color: white;
      height: 100%;
      width: 98%;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding-right: 1mm;
    `,
    DetailsContainer: styled.View`
      margin-top: ${props => !props.hasImage ? (props.columns == 'standard' ? props.imageRatio == 'portrait' ? '0px' : '0px' : props.columns == 'compact' ? props.imageRatio == 'portrait' ? '0px' : '0px' : '0px') : props.columns == 'standard' ? '5px' : props.columns == 'compact' ? '2px' : '5px'};
      display: block;
      flex-grow: 0;
      flex-shrink: 1;
      overflow: hidden;
      width: 100%;
    `,
    ImagePlaceholder: styled.View`
      height: 100%;
      background-color: #e6e7e8;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #9d9d9d;
      border-radius: 2px;
      padding: 2mm;
      margin-right: 1mm;
    `
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/VlpProductCard.styles.tsx